var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"hidden","id":"token","name":"token"},domProps:{"value":_vm.token}}),_c('iframe',{attrs:{"src":"static/carinfomap/dashboard.html","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }